import '@maptiler/sdk/dist/maptiler-sdk.css';
import './styles.css';
import { config, Map, helpers, Marker, MapStyle } from '@maptiler/sdk';
import { ElevationProfileControl } from "@maptiler/elevation-profile-control";

const container = document.getElementById('app');

if (!container) throw new Error('There is no div with the id: "map" ');

const urlParams = new URLSearchParams(window.location.search); 
const key = urlParams.get('key') || 'YOUR_MAPTILER_API_KEY_HERE';
config.apiKey = key;
const dataId = '40a41e21-8d5b-4393-837d-3f0a1edbb168';
const map = new Map({ 
  container, 
  hash: false,
  center: [0.57705, 42.68311],
  zoom: 12.22,
  style: MapStyle.OUTDOOR
});

map.on('load', () => {

  helpers.addPolyline(map, {
    data: dataId, 
    lineColor: '#66f', 
    lineWidth: 4, 
    outline: true, 
    outlineWidth: 2
  });

  const marker = new Marker()
  .setLngLat([0, 0])
  .addTo(map);

  // Create an instance (with no options)
  const epc = new ElevationProfileControl({
    visible: true,
    size: "50%",
    onMove: (data) => {
      marker.setLngLat(data.position)
    },
  });

  // Add it to your map
  map.addControl(epc);

  // Add some data (from a URL or a MapTiler Data UUID)
  epc.setData(dataId);

});
